import React from 'react'

import { IconExternalLinks } from '@avantstay/backoffice-vectors'

import { getThumbnailUrl } from '../../utils'
import { Avatar } from '../Avatar'
import { Badge, BadgeColors } from '../Badge'
import { MiddleEllipsis } from '../MiddleEllipsis'
import * as S from './HomeInfo.styles'
import { HomeInfoProps, HomeInfoState } from './HomeInfo.types'

export const HomeInfo = ({
  state = HomeInfoState.Normal,
  thumbnail,
  title,
  titleBadge,
  region,
  url,
  avatarSize,
  maxWidth,
  isLarge,
}: HomeInfoProps): JSX.Element => {
  const handleClick = () => {
    window.open(url, '_blank')
  }

  return (
    <S.HomeInfoRoot maxWidth={maxWidth}>
      <Avatar
        noBorder
        src={
          thumbnail &&
          getThumbnailUrl({
            originalSrc: thumbnail,
          })
        }
        initials={thumbnail ? undefined : title[0]}
        widthValue={avatarSize}
        heightValue={avatarSize}
      />
      <S.HomeTitleAndRegion>
        <S.HomeTitle state={state} isLarge={isLarge}>
          <MiddleEllipsis data={title} tailLength={4} />
          {url && (
            <S.HomeUrl onClick={handleClick}>
              <IconExternalLinks />
            </S.HomeUrl>
          )}
        </S.HomeTitle>
        {region ? (
          <S.HomeRegion state={state} isLarge={isLarge}>
            {region}
          </S.HomeRegion>
        ) : null}
      </S.HomeTitleAndRegion>
      {titleBadge ? (
        <Badge badgeColor={BadgeColors.accent} styles={{ marginLeft: 'auto' }}>
          {titleBadge}
        </Badge>
      ) : null}
    </S.HomeInfoRoot>
  )
}
